import { userHasAccessToAllEndpoints } from '@splunk/olly-common/RBAC';

angular.module('signalview.linkableModal', []).service('linkableModalService', [
    '$rootScope',
    '$timeout',
    '$log',
    'urlOverridesService',
    'currentUser',
    function ($rootScope, $timeout, $log, urlOverridesService, currentUser) {
        let activeModal = null;
        const modalRegistry = {};

        $rootScope.$on('React:$routeUpdate', () => activate());
        $timeout(() => activate());

        return {
            register,
            open,
        };

        // openFn should return sfxModal instance
        function register(title, openFn, withTabs, endpoints = []) {
            if (modalRegistry[title]) {
                $log.warn('Modal with same id already registered. Replacing.');
            }

            modalRegistry[title] = { openFn, withTabs, endpoints };
        }

        function activate() {
            const modalTitle = urlOverridesService.getActiveModal();
            if (!modalRegistry[modalTitle]) {
                urlOverridesService.clearActiveModal();
                activeModal = null;
                return;
            }

            if (modalTitle === activeModal) {
                return;
            }

            open(modalTitle);
        }

        async function open(title) {
            const modal = modalRegistry[title];
            if (!modal) {
                $log.warn(`No modal with id:"${title}" registered.`);
                return;
            }

            if (modal?.endpoints?.length > 0) {
                const caps = await currentUser.userCapabilities();
                const hasAccess = userHasAccessToAllEndpoints(modal.endpoints, caps);
                if (!hasAccess) return;
            }

            activeModal = title;
            const modalInstance = modal?.openFn();
            modalInstance?.opened?.then(() => urlOverridesService.setActiveModal(title));
            modalInstance?.closed?.then(() => {
                urlOverridesService.clearActiveModal();
                if (modal?.withTabs) {
                    urlOverridesService.clearTab();
                }
            });

            return modalInstance;
        }
    },
]);
